import { config } from '@/sahara-core-config';
import { ApolloClient, InMemoryCache, gql, NormalizedCacheObject } from '@apollo/client'


export function getSubgraphClient(networkId : number) : ApolloClient<NormalizedCacheObject>{
    // console.log(config.deployments[networkId].subgraphUrl)
    const client = new ApolloClient({
        uri: config.deployments[1].subgraphUrl,
        cache: new InMemoryCache(),
    })
    return client;
}

export interface DepositEvent {
    currency:string,
    amount:string,
    commitment: string,
    blockNumber: string,
    timestamp: number,
    index: number,
    from: string,
    transactionHash : string,

  }
export interface WithdrawalEvent {
    currency:string,
    amount:number,
    commitment: string,
    blockNumber: string,
    timestamp: number,
    index: number,
    fee: number,
    transactionHash : string
  }


export interface DepositEventData {
    depositEvents : DepositEvent[],
  }

  export interface DepositWithdrawEventData {
    depositEvents : DepositEvent[],
    withdrawEvents : WithdrawalEvent[],
  }
// export interface DepositEventVars {
//     currency: string,
//     amount: string,
//     fromBlock: string
//   }
export interface DepositCommitmentEventVars {
    currency: string,
    amount: string,
    commitment: string
  }

export const GET_DEPOSIT_EVENTS = gql`
  query deposits($currency: String!, $amount: String!, $fromBlock: String!) {
    deposits(where: {
            currency: $currency 
            amount: $amount 
            blockNumber_gte: $fromBlock}) {
        currency
        amount
        commitment
        blockNumber
        timestamp
        index
        transactionHash
    }
  }
`;

export const GET_DEPOSIT_BLOCK_BY_COMMITMENT = gql`
  query deposits($currency: String!, $amount: String!, $commitment: String!) {
    deposits(where: {
            currency: $currency 
            amount: $amount 
            commitment : $commitment}) {
                timestamp
                transactionHash
                from
                commitment
                amount
                currency
                blockNumber
    }
  }
`;

export const GET_DEPOSIT_WITHDRAWAL_EVENTS = gql`
  query deposits($address: String!) {
    deposits(where: {from: $address }) {
        timestamp
        transactionHash
        amount
        currency
        blockNumber
    }
    withdrawals(where: {to: $address }) {
        timestamp
        transactionHash
        amount
        currency
        blockNumber
        fee
    }
  }
`;



export async function getDepositByCommitment(
    currency : string, 
    amount : number,
    commitment : string,
    networkId : number) {

    const client = getSubgraphClient(networkId);
    const depositsQuery = `
    query {
        deposits(where: {
            amount: "`+amount+`", 
            currency: "`+currency+`",
            commitment: "`+commitment+`"
        }) {
            blockNumber
        }
    }
     `
    const data : any = await client.query({
      query: gql(depositsQuery),
    })
    console.log(data)
    // return data['deposits'][0] ? data['deposits'][0] : [];
}

